import React from 'react'
import { useLocalBusinessCard } from '../../store'
import { Page } from '../../components/page'
import { Skeleton } from '../../components/skeleton'
import styled from 'styled-components'
import { Image } from 'antd-mobile'

const StyledPage = styled(Page)`
  padding: 1.25rem;
`
const Text = styled.div`
  width: 100%;
  margin-top: 0.5rem;
  text-align: center;
  font-size: 0.875rem;
`
export const Poster: React.VFC = () => {
  const card = useLocalBusinessCard()
  return (
    <Skeleton
      value={card}
      render={card => (
        <StyledPage>
          <Image
            width="100%"
            fit="contain"
            src={card.posterUrl}
            alt="海报名片"
          />
          <Text>长按图片下载图片</Text>
        </StyledPage>
      )}
    />
  )
}
